import { Text } from '@chakra-ui/react'

import Image from '@/features/Services/components/atoms/Images/CCTVPolicies'

import { TITLE_H1_STYLE, TITLE_H3_STYLE, PARAGRAPH_STYLE } from './style'

import { Policy } from '@/features/Services/types'

const HREF = 'serviceCCTV'

const TITLE = 'CCTV Policy'
const SUBTITLE = 'นโยบายความเป็นส่วนตัว สำหรับการใช้กล้องโทรทัศน์วงจรปิด'

const PRIMARY_COLOR = '#73BBFF'
const SECONDARY_COLOR = '#F1F8FF'
const LINK_IMAGE = '/images/services/cctv/4.png'
const GRADIENT = `linear-gradient(0deg, rgba(115, 187, 255, 0.5) 0%, ${PRIMARY_COLOR} 100%)`

const POLICY: Policy[] = [
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        CCTV Policy
        <br />
        นโยบายความเป็นส่วนตัวสำหรับ การใช้กล้องโทรทัศน์วงจรปิด
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        สำหรับธุรกิจที่มีการติดตั้งกล้องโทรทัศน์วงจรปิด (CCTV)
        ไม่ว่าจะในที่ทำงาน ร้านค้า โรงงาน ฯลฯ
        ซึ่งเป็นการเก็บข้อมูลส่วนบุคคลประเภทรูปถ่ายและภาพเคลื่อนไหวใบหน้าของบุคคล
      </Text>
    ),
    image: '/images/services/cctv/cctv-header.svg',
    imageAspectRatio: 645 / 658,
    button: {
      label: 'สร้าง Policy ตอนนี้!',
      href: '/create/policy?template=cctv',
      logEvent: {
        ga: { category: TITLE, action: 'Click create policy' },
      },
    },
  },
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        CCTV Policy
        <br />
        จำเป็นอย่างไร ?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        เพื่อแจ้งจุดประสงค์และแนวปฏิบัติของการประมวลผล ข้อมูลส่วนบุคคลตาม พ.ร.บ.
        คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 สำหรับธุรกิจที่มีการเก็บรวบรวม ใช้
        หรือ เปิดเผยข้อมูลส่วนบุคคลของลูกค้าหรือผู้ใช้งานที่ได้จากกล้องวงจรปิด
        ต้องจัดทำ นโยบายความเป็นส่วนตัว สำหรับกล้องวงจรปิด (CCTV Policy)
      </Text>
    ),
    image: '/images/services/cctv/2.png',
    imageAspectRatio: 1,
  },
  {
    title: (
      <Text as="h2" sx={TITLE_H3_STYLE}>
        CCTV Policy
        <br />
        ครอบคลุมเรื่องอะไรบ้าง?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        นโยบายความเป็นส่วนตัวสำหรับกล้องวงจรปิด (CCTV Policy) ครอบคลุมไปถึง
        ความหมาย วิธีการใช้ ประเภทของข้อมูลส่วนบุคคลที่จัดเก็บและวัตถุประสงค์
        ในการเก็บรวบรวม ใช้ หรือเปิดเผยภาพนิ่ง ภาพเคลื่อนไหว เสียง
        ของเจ้าของข้อมูลส่วนบุคคล ฐานทางกฎหมาย และสิทธิของเจ้าของข้อมูลส่วนบุคคล
      </Text>
    ),
    checkList: [
      'ปรับใช้ได้กับทุกธุรกิจ',
      'สอดคล้องกับ PDPA',
      'สะดวกในการติดตั้ง',
    ],
    image: <Image />,
  },
]

export default {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  POLICY,
  HREF,
  LINK_IMAGE,
  GRADIENT,
  TITLE,
  SUBTITLE,
}
